(function(angular){
	'use strict';

	angular
		.module('collapseModule')
		.directive('collapse', [
			'$document',
			'$parse',
			'$timeout',
			'$window',
			collapseFunction
		]);

	function collapseFunction($document, $parse, $timeout, $window) {
		return {
			restrict : 'A',
			link : function($scope, $element, $attrs) {

				var collapse;
				var transitionDuration = $attrs.collapseTransitionDuration ? $attrs.collapseTransitionDuration : 250;
				var transitionDurationCssProp = (transitionDuration / 1000) + 's';

				var update = function(collapse) {
					if (collapse) {
						$element.css({
							height: 0,
							opacity: 0,
							overflow: 'hidden',
							transitionDuration: transitionDurationCssProp,
							transitionProperty: 'all',
							margin: 0,
							paddingTop: 0,
							paddingBottom: 0
						});
					} else {
						var originalEl = angular.element($element);
						var clonedEl = originalEl.clone(true);
						clonedEl.css({
							position: 'absolute',
							left: '-10000px',
							top: '-10000px',
							width: originalEl[0].getBoundingClientRect().width + 'px',
							height: 'auto',
							paddingTop: '',
							paddingBottom: ''
						});
						var body = angular.element($document[0].body);
						body.append(clonedEl);
						var height = clonedEl[0].clientHeight;
						clonedEl.remove();

						$element.css({
							height: height + 'px',
							transitionDuration: transitionDurationCssProp,
							transitionProperty: 'all',
							opacity: 1,
							margin: '',
							paddingTop: '',
							paddingBottom: ''
						});

						$timeout(function() {
							$element.css({
								overflow: ''
							});
						}, transitionDuration);
					}
				};

				var timer;

				angular.element($window).bind('resize', function(){
					$timeout.cancel(timer);
					timer = $timeout(function() {
						collapse = $parse($attrs.collapse)($scope);
						update(collapse);
					}, 500);
				});

				$scope.$watch($attrs.collapse, function(newValue) {
					collapse = newValue;
					update(newValue);
				});
			}
		};
	}
})(window.angular);